(ns frontend.ui.component.lp-portal.report.company.value-chart.view
  (:require
   [clojure.string :as s]
   [frontend.ui.component.chart.view :refer [chart]]
   [frontend.ui.component.lp-portal.card.view :refer [card]]
   [frontend.ui.component.lp-portal.text-content.view :as text-content]))

(defn valuation-card
  [valuation props]
  [card
   {:title "Valuation"}
   [:<>
    [chart valuation props]
    (text-content/optional-footnote valuation props)]])
